export const knownActions = {
    PERFORM_ORAMA_SEARCH: 'PERFORM_ORAMA_SEARCH',
    OPTIMIZE_QUERY: 'OPTIMIZE_QUERY',
    GENERATE_QUERIES: 'GENERATE_QUERIES',
    ACTION_PLAN: 'ACTION_PLAN',
    ASK_FOLLOWUP: 'ASK_FOLLOWUP',
    GIVE_REPLY: 'GIVE_REPLY',
    GET_SEGMENT: 'GET_SEGMENT',
    GET_TRIGGER: 'GET_TRIGGER',
    SELECT_SEGMENT_PROBABILITY: 'SELECT_SEGMENT_PROBABILITY',
    SELECT_TRIGGER_PROBABILITY: 'SELECT_TRIGGER_PROBABILITY',
};
export const knownActionsArray = Object.values(knownActions);
